<template>
  <!-- 数字农业·土地交易产权·二级页面 -->
  <div>
    <div id="lang" ref="lang">
      <div class="echarts_border">
        <!-- 农村产权抵押贷款总数据 -->
        <div class="echart_zonglans">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font">农村产权抵押贷款金额</span>
          </div>
        </div>
        <div id="echart_Lang_one"></div>
        <!-- 本年与去年同期对比 -->
        <div class="echart_zonglan">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font">农村产权抵押贷款金额同比</span>
          </div>
        </div>
        <div id="echart_Lang_two"></div>
        <!-- 近五年变化趋势 -->
        <div class="echart_zonglan">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font">农村产权贷款金额变化趋势</span>
          </div>
        </div>
        <div id="echart_Lang_three"></div>
        <p class="text-center">数据来源：{{ Data_txt }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  components: {},
  props: {},
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),

      // 农村产权抵押贷款数据
      oneMonth: [],
      oneNumber: [],

      // 本年与去年对比数据
      twoLastYearNum: [],
      twoThisYearNum: [],
      twoYear: [],
      lastYears: "",
      thisYears: "",

      // 近五年变化趋势
      threeYear: [],
      threeNum: [],
      Data_txt: "",
      lastMn: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 农村产权抵押贷款总数据
    init_one() {
      // 调取数据
      var data_changquan = plOtherDataInterface.getLoanList();
      this.oneMonth = data_changquan.map((item) => item.theMonth);
      this.oneNumber = data_changquan.map((item) => item.theNumber);

      var myChart = echarts.init(document.getElementById("echart_Lang_one"));
      var option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return `
              <div style="font-size:12px;">农村产权贷款抵押金额：${params[0].data}${params[0].seriesName}</div>
            `;
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.oneMonth,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位（万元）",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "万元",
            type: "line",
            smooth: false,
            lineStyle: {
              color: "#4C96FC",
            },
            label: {
              show: true,
              position: "top",
               color: "#fff",
            },
            showSymbol: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#347EBD",
                },
                {
                  offset: 1,
                  color: "#266B84",
                },
              ]),
            },
            data: this.oneNumber,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 本年与去年对比
    init_two() {
      // 调取数据
      var data_duibi = plOtherDataInterface.getLoanThisYearLastYear();
      var lastYear = data_duibi.lastYear;
      var thisYear = data_duibi.thisYear;
      this.twoLastYearNum = lastYear.map((item) => item.theNumber);
      this.twoThisYearNum = thisYear.map((item) => item.theNumber);
      this.twoYear = thisYear.map((item) => item.theOnlyMonth + "月");
      this.lastYears = data_duibi.lastYearNumber;
      this.thisYears = data_duibi.thisYearNumber;
      var last_month = lastYear.map((item) => item.theMonth);
      var this_month = thisYear.map((item) => item.theMonth);
      last_month = last_month.splice(",");
      this_month = this_month.splice(",");
      // console.log(last_month);
      // 需要根据索引值判断进行渲染
      var myChart = echarts.init(document.getElementById("echart_Lang_two"));
      var option = {
        color: ["#FDB628", "#EB6F49"],
        legend: {
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            console.log(params);
            let twoYear = 2021;
            if (params.length == 1) {
              if ((params[0].seriesName == 2020)) {
                return `<div style="font-size:12px;">农村产权抵押贷款金额同比(同月)：${this.lastMn}月${params[0].data}万元</div>
                `;
              }
              if ((params[0].seriesName == 2021)) {
                return `<div style="font-size:12px;">农村产权抵押贷款金额同比(同月):${twoYear}-${params[0].name}${params[0].data}万元</div>
            `;
              }
            } else {
              return `<div style="font-size:12px;">农村产权抵押贷款金额同比(同月)：${this.lastMn}月${params[0].data}万元</div>

              <div style="font-size:12px;">农村产权抵押贷款金额同比(同月)：${twoYear}-${params[1].name}${params[1].data}万元</div>
            `;
            }
          },
        },
        xAxis: {
          type: "category",
          data: this.twoYear,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          trigger: true,
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: ["#ccc"],
              width: 1,
              type: "dashed",
            },
          },
        },
        yAxis: {
          name: "单位（万元）",
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: ["#ccc"],
              width: 1,
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "bar",
            name: this.lastYears,
            data: this.twoLastYearNum,
          },
          {
            type: "bar",
            name: this.thisYears,
            data: this.twoThisYearNum,
          },
        ],
      };
      myChart.on("mouseover", (params) => {
        switch (params.name) {
          case "01月":
            this.lastMn = last_month[0];
            break;
          case "02月":
            this.lastMn = last_month[1];
            break;
          case "03月":
            this.lastMn = last_month[2];
            break;
          case "04月":
            this.lastMn = last_month[3];
            break;
          case "05月":
            this.lastMn = last_month[4];
            break;
          case "06月":
            this.lastMn = last_month[5];
            break;
          case "07月":
            this.lastMn = last_month[6];
            break;
          case "08月":
            this.lastMn = last_month[7];
            break;
          case "09月":
            this.lastMn = last_month[8];
            break;
          case "10月":
            this.lastMn = last_month[9];
            break;
          case "11月":
            this.lastMn = last_month[10];
            break;
          case "12月":
            this.lastMn = last_month[11];
            break;
          default:
            undefined;
            break;
        }
      });
      option && myChart.setOption(option);
    },
    // 近五年变化趋势
    init_three() {
      var data_wunian = plOtherDataInterface.getLoanFiveYearList();
      this.threeYear = data_wunian.map((item) => item.theYear);
      this.threeNum = data_wunian.map((item) => item.theNumber);

      var myChart = echarts.init(document.getElementById("echart_Lang_three"));
      var option = {
        color: ["#FFC32B"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            // console.log(params);
            return `
              <div style="font-size:12px;">农村产权贷款金额变化趋势：${params[0].data}${params[0].seriesName}</div>
            `;
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.threeYear,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位（万元）",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "万元",
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#FFC32B",
            },
            label: {
              show: true,
              position: "top",
               color: "#fff",
            },
            showSymbol: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#5E815B",
                },
                {
                  offset: 1,
                  color: "#1B646E",
                },
              ]),
            },
            data: this.threeNum,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[4].lang;
    },
  },
  created() {},
  mounted() {
    this.init_one();
    this.init_two();
    this.init_three();
    this.Sources();
  },
};
</script>
<style lang="less" scoped>
#lang {
  background: #15606e;
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  border-top: 1px solid rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-top: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}
#echart_Lang_three,
#echart_Lang_two,
#echart_Lang_one {
  height: 18.75rem;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_farming/Lang.vue